import * as routes from '../../routes';
import initUserInfo from './initUserInfo';

const initUserInfoAjax = () => {
  fetch(routes.front_public_ajax_user_info())
    .then(response => response.json())
    .then(userInfo => {
      function execute(callback) {
        try {
          callback(userInfo);
        } catch (e) {
          if (console && console.error) {
            console.error(e);
          }
        }
      }

      const queuedCallbacks = window.onUserInfoLoad;

      for (let i = 0; i < queuedCallbacks.length; i++) {
        execute(queuedCallbacks[i]);
      }
      window.onUserInfoLoad.push = execute;
    });

  initUserInfo();
};

export default initUserInfoAjax;

